// Shared Joyride styles for consistent tour appearance across the application
export const customJoyrideStyles = {
  options: {
    arrowColor: "#2C2C2E", // Background color of the tooltip
    backgroundColor: "#2C2C2E", // Tooltip background color (dark theme)
    overlayColor: "rgba(0, 0, 0, 0.4)", // Slightly dark overlay
    primaryColor: "#2C2C2E", // Highlight color
    textColor: "#ffffff", // White text
    width: 400, // Width of tooltip
    zIndex: 1000,
  },
  tooltip: {
    borderRadius: "12px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Smooth shadow
    padding: "20px",
  },
  tooltipContainer: {
    lineHeight: 1.4,
    textAlign: 'left',
  },
  tooltipTitle: {
    color: "#FFFFFF",
    fontFamily: "'AvertaSemiBold', sans-serif", // Custom font
    fontSize: "24px",
    letterSpacing: "-0.49px",
    paddingLeft: "0px", // Removes unwanted padding
    textAlign: "left", // Aligns text to left
  },
  tooltipContent: {
    color: "#FFFFFF",
    fontFamily: "'AvertaSemiBold', sans-serif", // Custom font
    fontSize: "16px",
    letterSpacing: "-0.4px",
    paddingLeft: "0px", // Removes unwanted padding
    textAlign: "left", // Aligns text to left
  },
  tooltipFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonClose: {
    color: "#FFFFFF",
    fontSize: "18px",
  },
  buttonNext: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "14px",
    fontWeight: "600",
    borderRadius: "8px",
    padding: "8px 16px",
  },
  buttonBack: {
    color: "#D1D1D1",
    fontSize: "14px",
    fontWeight: "500",
  },
  beacon: {
    backgroundColor: "#007bff", // Blue color to match RouteTourManager
    border: "2px solid white",
    boxShadow: "0 0 0 4px rgba(0, 123, 255, 0.3)",
    animation: "pulse 2s infinite",
  },
};

// CSS for pulse animation - can be injected into any component
export const pulseAnimationCSS = `
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.7;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

// Custom Joyride locale configuration
export const customJoyrideLocale = {
  back: 'Back',
  close: 'Close',
  last: 'Got it!',
  next: 'Next',
  skip: 'Skip',
}; 